export default __webpack_public_path__ + "static/media/yayinlar4.75c68647.png";